import React from 'react';
import {
    WETSUIT_SPRING_COLD,
    WETSUIT_SPRING_MILD,
    WETSUIT_SPRING_WARM,
    WETSUIT_SUMMER_COOL,
    WETSUIT_SUMMER_WARM,
    WETSUIT_AUTUMN_COLD,
    WETSUIT_AUTUMN_MILD,
    WETSUIT_AUTUMN_WARM,
    WETSUIT_WINTER_COLD,
    WETSUIT_WINTER_MILD,
    WETSUIT_SPRING_COLD_SV,
    WETSUIT_SPRING_MILD_SV,
    WETSUIT_SPRING_WARM_SV,
    WETSUIT_SUMMER_COOL_SV,
    WETSUIT_SUMMER_WARM_SV,
    WETSUIT_AUTUMN_COLD_SV,
    WETSUIT_AUTUMN_MILD_SV,
    WETSUIT_AUTUMN_WARM_SV,
    WETSUIT_WINTER_COLD_SV,
    WETSUIT_WINTER_MILD_SV
} from './WetsuitConstants';

const getSeason = (month) => {
    if (month >= 3 && month <= 5) return 'Spring';
    if (month >= 6 && month <= 8) return 'Summer';
    if (month >= 9 && month <= 11) return 'Autumn';
    return 'Winter';
};

const getWetsuitRecommendation = (waterTemperature, season, language) => {
    switch (season) {
        case 'Spring':
            if (waterTemperature >= 0 && waterTemperature < 6) return language === 'english' ? WETSUIT_SPRING_COLD : WETSUIT_SPRING_COLD_SV;
            if (waterTemperature >= 6 && waterTemperature < 9) return language === 'english' ? WETSUIT_SPRING_MILD : WETSUIT_SPRING_MILD_SV;
            if (waterTemperature >= 9 && waterTemperature < 13) return language === 'english' ? WETSUIT_SPRING_WARM : WETSUIT_SPRING_WARM_SV;
            break;
        case 'Summer':
            if (waterTemperature >= 13 && waterTemperature < 18) return language === 'english' ? WETSUIT_SUMMER_COOL : WETSUIT_SUMMER_COOL_SV;
            if (waterTemperature >= 18) return language === 'english' ? WETSUIT_SUMMER_WARM : WETSUIT_SUMMER_WARM_SV;
            break;
        case 'Autumn':
            if (waterTemperature >= 5 && waterTemperature < 9) return language === 'english' ? WETSUIT_AUTUMN_COLD : WETSUIT_AUTUMN_COLD_SV;
            if (waterTemperature >= 9 && waterTemperature < 13) return language === 'english' ? WETSUIT_AUTUMN_MILD : WETSUIT_AUTUMN_MILD_SV;
            if (waterTemperature >= 13 && waterTemperature < 18) return language === 'english' ? WETSUIT_AUTUMN_WARM : WETSUIT_AUTUMN_WARM_SV;
            break;
        case 'Winter':
            if (waterTemperature >= 0 && waterTemperature < 6) return language === 'english' ? WETSUIT_WINTER_COLD : WETSUIT_WINTER_COLD_SV;
            if (waterTemperature >= 6 && waterTemperature < 9) return language === 'english' ? WETSUIT_WINTER_MILD : WETSUIT_WINTER_MILD_SV;
            break;
        default:
            return language === 'english' ? 'Check later for recommendations' : 'Kontrollera senare för rekommendationer';
    }

    return language === 'english' ? 'Conditions are outside the current recommendation range.' : 'Förhållandena ligger utanför det nuvarande rekommendationsintervallet.';
};

const WetsuitRecommendation = ({ waterTemperature, language }) => {
    const date = new Date();
    const month = date.getMonth() + 1;
    const season = getSeason(month);

    if (waterTemperature === null || waterTemperature === undefined) {
        return <p>{language === 'english' ? 'Waiting for water temperature…' : 'Väntar på vattentemperatur…'}</p>;
    }

    const wetsuitRecommendation = getWetsuitRecommendation(waterTemperature, season, language);
    return <p>{wetsuitRecommendation}</p>;
};

export default WetsuitRecommendation;
